/* Defines container types for logging.
   Unfortunately, the naming here is a little confusing:
   This is not to be confused with the container-type.js file whose values map to the `container` property in logs */
export default {
  Author: 'Author',
  Team: 'Team',
  User: 'User',
};
